<template>
  <div class="main">
    <div class="main_head">
      <div class="nav_line">
        <div class="nav_left">
          <img
            src="../../static/images/logo.png"
            alt=""
            class="logo"
          >
          <div class="btn_list">
            <div
              v-for="(item, index) in menuRouteList"
              :key="index + '111'"
              :class="
                item['active']
                  ? 'btn_item btn_active'
                  : 'btn_item'
              "
              @mouseenter="handIconChange(index, item['active'])"
              @mouseleave="
                handIconChangeBack(index, item['active'])
              "
              @click="handClick(index)"
            >
              <el-tooltip
                :content="item.content"
                :open-delay="1000"
                class="item"
                effect="dark"
                placement="bottom-start"
              >
                <div
                  :class="
                    item['active']
                      ? 'btn_center center_active'
                      : 'btn_center'
                  "
                >
                  <img
                    :src="iconList[index]['showIcon']"
                    class="icon"
                  >
                  {{ item.name }}
                </div>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div class="nav_right">
          <el-dropdown>
            <span>
              {{ userInfo.account
              }}<i class="el-icon-arrow-down el-icon--right" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="goBackManange">返回管理端</el-dropdown-item>
              <el-dropdown-item
                @click.native="handLogOut"
              >退出登录</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="sub_btn_list">
        <div
          v-for="(item, index) in subList"
          :key="index + '222'"
          class="btn_item"
        >
          <el-tooltip
            v-if="!item['type']"
            :open-delay="1000"
            :disabled="!item.tip"
            :content="item.tip"
            class="item"
            effect="dark"
            placement="bottom-start"
          >
            <el-button
              :disabled="item.disabled"
              router-prevent-re-click="1000"
              size="small"
              class="lay_btn"
              @click="handBtnClick(item.prop)"
            >
              {{ item.label }}
            </el-button>
          </el-tooltip>
          <el-button
            v-if="item['type'] === 'switch'"
            :disabled="item.disabled"
            router-prevent-re-click="1000"
            size="small"
            class="lay_btn"
            @click="
              handBtnClick(item['options'][item['state']].prop)
            "
          >
            {{ item["options"][item["state"]].label }}
          </el-button>
          <!-- 数据分析的type为select -->
          <el-dropdown
            v-if="item['type'] === 'select'"
            @command="handBtnClick"
          >
            <span class="el-dropdown-link">
              新建视图<i
                class="el-icon-arrow-down el-icon--right"
              />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(subItem, subIndex) in item['options']"
                :key="subIndex"
                :command="subItem['prop']"
              >{{ subItem["label"] }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="content">
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </div>
    <!-- TODO start -->
    <div class="layout_bottom">
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#404040', color: '#fff' }"
        style="width: 100%"
        height="126"
        class="tableBox"
      >
        <el-table-column
          align="center"
          prop="type"
          width="200"
          label="符号"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.type === 1">
              <img
                class="inforImage"
                src="../../static/images/information-icon.png"
                alt=""
              >
            </div>
            <div v-else>
              <img src="" alt="" ><img
                class="inforImage"
                src="../../static/images/warning - icon.png"
                alt=""
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="logTime"
          width="200"
          label="时间"
        >
          <template slot-scope="scope">
            <span>{{ formatDate(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="type"
          width="200"
          label="类型"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.type === 1 ? "信息" : "错误"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="source"
          width="200"
          label="源"
        />
        <el-table-column align="center" prop="message" label="消息" />
      </el-table>
      <!-- <div class="export-fixed">
        <div class="export-text">消息</div>
        <div class="export-text">
          <el-button type="primary" size="small">导出试验消息</el-button>
        </div>
      </div> -->
    </div>
    <!-- TODO end -->
    <!-- <keep-alive :include="cachedViews"> -->
    <!-- </keep-alive> -->
  </div>
</template>

<script>
import btnJson from './btnList';
import {
    refresh,
    getRoutes,
    getLogData,
    getUserExperimentState
    // testFail
} from '@/api/login';
import {logout} from '@/api/user'
// import { getRoutes } from '@/api/login';
import { setToken, getToken, setRefreshToken, removeToken } from '@/utils/auth';
export default {
    name: 'Layout',
    data() {
        return {
            tableData: [],
            iconList: [
                {
                    showIcon: '../../static/images/add.png',
                    normal: '../../static/images/add.png',
                    select: '../../static/images/add_s.png',
                    click: '../../static/images/add_c.png'
                },
                {
                    showIcon: '../../static/images/feed.png',
                    normal: '../../static/images/feed.png',
                    select: '../../static/images/feed_s.png',
                    click: '../../static/images/feed_c.png'
                },
                {
                    showIcon: '../../static/images/casino.png',
                    normal: '../../static/images/casino.png',
                    select: '../../static/images/casino_s.png',
                    click: '../../static/images/casino_c.png'
                },
                {
                    showIcon: '../../static/images/keyboard.png',
                    normal: '../../static/images/keyboard.png',
                    select: '../../static/images/keyboard_s.png',
                    click: '../../static/images/keyboard_c.png'
                },
                {
                    showIcon: '../../static/images/options.png',
                    normal: '../../static/images/options.png',
                    select: '../../static/images/options_s.png',
                    click: '../../static/images/options_c.png'
                },
                {
                    showIcon: '../../static/images/border.png',
                    normal: '../../static/images/border.png',
                    select: '../../static/images/border_s.png',
                    click: '../../static/images/border_c.png'
                },
                {
                    showIcon: '../../static/images/turned.png',
                    normal: '../../static/images/turned.png',
                    select: '../../static/images/turned_s.png',
                    click: '../../static/images/turned_c.png'
                },
                {
                    showIcon: '../../static/images/info.png',
                    normal: '../../static/images/info.png',
                    select: '../../static/images/info_s.png',
                    click: '../../static/images/info_c.png'
                }
            ],
            routerList: [],
            subList: [],
            menuRouteList: [],
            userInfo: {}
        };
    },
    watch: {
        '$store.state.event': {
            handler(value) {
                if (!value) return;
                let temData = this.subList;
                for (let item in temData) {
                    if (
                        temData[item]['type'] &&
                        temData[item]['type'] === 'switch' &&
                        temData[item]['options'][temData[item]['state']][
                            'prop'
                        ] === value
                    ) {
                        if (
                            temData[item]['state'] ===
                            temData[item]['options']['length'] - 1
                        ) {
                            temData[item]['state'] = 0;
                        } else {
                            temData[item]['state'] += 1;
                        }
                    }
                }
                this.subList = temData;
                // console.log('subList:', this.subList);
            },
            deep: true
        },
        '$store.state.disabled': {
            handler(value) {
                let temData = this.subList;
                if (!value) return false;
                for (let item in temData) {
                    if (
                        temData[item]['label'] &&
                        temData[item]['label'] === value
                    ) {
                        temData[item]['disabled'] = true;
                    } else if (temData[item]['type']) {
                        let subData = temData[item]['options'];
                        for (let subItem in subData) {
                            if (subData[subItem]['prop'] === value) {
                                temData[item]['disabled'] = true;
                            }
                        }
                    }
                }
                this.subList = [];
                this.subList = temData;
            },
            deep: true
        }
    },
    mounted() {
        this.loadLog();
        this.getMenuRoutes(() => {
            let temPageCount = sessionStorage.getItem('pageCount');
            if (temPageCount) {
                this.handClick(temPageCount);
            } else {
                this.handClick(0);
            }
            this.$store.commit('setDisabled', '');
        });
        getUserExperimentState().then((res) => {
            // console.log('res.data:', res.data);
            if (res.data.status === 1 || res.data.status === 3) {
                sessionStorage.setItem(
                    'masterNumber',
                    res.data.masterControllerNumber
                );
                sessionStorage.setItem('number', res.data.experimentNumber);
                this.$message({
                    message: '已载入进行中的试验',
                    type: 'success'
                });
            }
            sessionStorage.setItem('epStatus', res.data.status);
        });
        // testFail().then(res => {
        //     console.log('res', res);
        // }).catch(err => {
        //     console.log('err', err);
        // });
    },
    created() {
        let token =
            decodeURIComponent(
                (new RegExp('[?|&]token=' + '([^&;]+?)(&|#|;|$)').exec(
                    location.href
                ) || ['', ''])[1].replace(/\+/g, '%20')
            ) || null;
        let refreshToken =
            decodeURIComponent(
                (new RegExp('[?|&]refreshToken=' + '([^&;]+?)(&|#|;|$)').exec(
                    location.href
                ) || ['', ''])[1].replace(/\+/g, '%20')
            ) || null;
        let temToken = getToken();
        if (token && token !== temToken) {
            refresh('000000', refreshToken).then((res) => {
                sessionStorage.setItem('userInfo', JSON.stringify(res));
                this.userInfo = res;
            });
            setToken(token);
            setRefreshToken(refreshToken);
            sessionStorage.setItem('pageCount', 0);
            this.$store.commit('setToken', token);
        } else {
            this.userInfo =
                JSON.parse(sessionStorage.getItem('userInfo')) || {};
        }
    },
    methods: {
        loadLog(cursor) {
            // 1.成功且有数据，更新startime 为最后一条日志的时间
            var that = this;
            var cursorParams = '';
            if (cursor === undefined) {
                cursorParams = '';
            } else {
                cursorParams = cursor;
            }
            getLogData(cursorParams)
                .then((response) => {
                    if (response.success && response.data.logs.length > 0) {
                        var data = response.data.logs;
                        data.forEach((element) => {
                            that.tableData.unshift(element);
                        });
                    }

                    that.loadLog(response.data['cursor']);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        formatDate(date) {
            if (date !== '') {
                var newDate = new Date(date);
                var YY = newDate.getFullYear() + '-';
                var MM =
                    (newDate.getMonth() + 1 < 10
                        ? '0' + (newDate.getMonth() + 1)
                        : newDate.getMonth() + 1) + '-';
                var DD =
                    newDate.getDate() < 10
                        ? '0' + newDate.getDate()
                        : newDate.getDate();
                var hh =
                    (newDate.getHours() < 10
                        ? '0' + newDate.getHours()
                        : newDate.getHours()) + ':';
                var mm =
                    (newDate.getMinutes() < 10
                        ? '0' + newDate.getMinutes()
                        : newDate.getMinutes()) + ':';
                var ss =
                    newDate.getSeconds() < 10
                        ? '0' + newDate.getSeconds()
                        : newDate.getSeconds();
                return YY + MM + DD + ' ' + hh + mm + ss;
            } else {
                return null;
            }
        },
        // 获取菜单
        getMenuRoutes(done) {
            // 菜单接口
            getRoutes()
                .then((res) => {
                    console.log('菜单接口返回数据:', res);
                    let temList = this.$store.state.navList;
                    //console.log('菜单路由列表:', this.$store.state);
                    console.log('temList:', temList);
                    let temAry = [];
                    for (let item in res.data) {
                        let temStr = res.data[item]['path'].substr(11);
                        for (let subItem in temList) {
                            // console.log('str',temStr);
                            // console.log('temList[subItem][\'path\']',temList[subItem]['path']);
                            if (temStr === temList[subItem]['path']) {
                                let temObj = temList[subItem];
                                temObj['btnList'] = mapBtnList(
                                    res.data[item]['children'],
                                    temList[subItem]['btnList']
                                );
                                temAry.push(temObj);
                            }
                        }
                    }
                    this.menuRouteList = temAry;
                    console.log('菜单路由列表:', this.menuRouteList);
                    done();
                })
                .catch((_) => {});
            function mapBtnList(data, subData) {
                let temAry = [];
                for (let item in data) {
                    let temStr = data[item]['code'].split(':')[2];
                    // console.log(temStr,subData);
                    for (let subItem in subData) {
                        if (typeof subData[subItem] === 'string') {
                            if (subData[subItem] === temStr) {
                                temAry.push(subData[subItem]);
                            }
                        } else if (typeof subData[subItem] === 'object') {
                            for (let sunItem in subData[subItem]['options']) {
                                if (
                                    subData[subItem]['options'][sunItem] ===
                                    temStr
                                ) {
                                    temAry.push(subData[subItem]);
                                }
                            }
                        }
                    }
                }
                // console.log(temAry);
                return temAry;
            }
        },
        // 返回管理端
        goBackManange() {
            console.log(process.env.JUMPURL);
            window.open('http://' + process.env.JUMPURL,'_self');

        },
        // 退出登录
        handLogOut() {
            this.$confirm('确认退出？')
                .then((_) => {
                    removeToken();
                    // window.location.href =
                    //     'http://' + process.env.JUMPURL + '/#/login';
                    // this.$store.dispatch("LogOut").then(() => {
                        window.open('http://' + process.env.JUMPURL + '/#/login?type=1','_self');
                    // });
                })
                .catch((_) => {});
        },
        handIconChange(index, active) {
            if (active) return;
            let temList = this.iconList;
            temList[index]['showIcon'] = temList[index]['select'];
            this.iconList = temList;
        },
        handIconChangeBack(index, active) {
            if (active) return;
            let temList = this.iconList;
            temList[index]['showIcon'] = temList[index]['normal'];
            this.iconList = temList;
        },
        handClick(index) {
            let temStr = '';
            let temBtns = [];
            let temIconList = this.iconList;
            let temList = this.menuRouteList;
            let routes = this.$router.options.routes;
            let temID = sessionStorage.getItem('masterNumber');
            if (temList[index]['needID'] && !temID) {
                this.$message.error('请先创建试验');
                index = 0;
                // return;
            }
            sessionStorage.setItem('pageCount', index);
            for (let item in temIconList) {
                temIconList[item]['showIcon'] = temIconList[item]['normal'];
            }
            temIconList[index]['showIcon'] = temIconList[index]['click'];
            this.iconList = temIconList;
            for (let item in temList) {
                temList[item]['active'] = false;
            }
            // console.log('11', temList[index]['btnList']);
            for (let item in temList[index]['btnList']) {
                let temItem = temList[index]['btnList'][item];
                console.log('temItem:', temItem);
                if (typeof temItem === 'string') {
                    for (let subItem in btnJson) {
                        if (btnJson[subItem]['prop'] === temItem) {
                            temBtns.push(btnJson[subItem]);
                        }
                        // 在截图按钮后面增加录制和结束录制的按钮
                        if (
                            (btnJson[subItem]['prop'] === 'screenRecord' ||
                                btnJson[subItem]['prop'] === 'stopRecord') &&
                            temItem === 'screenshot'
                        ) {
                            temBtns.push(btnJson[subItem]);
                        }
                    }
                } else {
                    if (temItem['type'] === 'switch') {
                        let temAry = [];
                        for (let sunItem in temItem['options']) {
                            for (let subItem in btnJson) {
                                if (
                                    btnJson[subItem]['prop'] ===
                                    temItem['options'][sunItem]
                                ) {
                                    temAry.push(btnJson[subItem]);
                                }
                            }
                        }
                        if (
                            (temAry[0]['prop'] === 'preserveEp' ||
                                temAry[0]['prop'] === 'stopEp') &&
                            sessionStorage.getItem('epStatus') === '3'
                        ) {
                            temBtns.push({
                                type: 'switch',
                                state: 1,
                                options: temAry
                            });
                        } else {
                            temBtns.push({
                                type: 'switch',
                                state: 0,
                                options: temAry
                            });
                        }
                    }
                    if (temItem['type'] === 'select') {
                        let temAry = [];
                        for (let sunItem in temItem['options']) {
                            for (let subItem in btnJson) {
                                if (
                                    btnJson[subItem]['prop'] ===
                                    temItem['options'][sunItem]
                                ) {
                                    temAry.push(btnJson[subItem]);
                                }
                            }
                        }
                        temBtns.push({
                            disabled: false,
                            type: 'select',
                            state: 0,
                            options: temAry
                        });
                    }
                }
            }
            temList[index]['active'] = true;
            this.routerList = temList;
            console.log('temBtns:', temBtns);
            this.subList = temBtns;
            for (let i = 0; i < routes.length; i++) {
                if (routes[i]['path'] === temList[index]['path']) {
                    temStr = routes[i]['redirect'];
                    break;
                }
            }
            this.$router.push({
                path: temStr
            });
        },
        handBtnClick(event) {
            console.log(event);
            this.$store.commit('setEvent', event);
        }
    }
};
</script>

<style scoped>
.main_head {
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100px;
    background: #fff;
    border-bottom: 1px solid #e3e7ef;
}

.nav_line {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e3e7ef;
}

.nav_left {
    display: flex;
    flex-direction: row;
}

.nav_right {
    width: 100px;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.logo {
    width: 79px;
    height: 28px;
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
}

.btn_list {
    display: flex;
    flex-direction: row;
    background: #fff;
}

.btn_item {
    position: relative;
    /* min-width: 120px; */
    padding: 0 10px;
    /* height: 50px; */
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #fff;
    line-height: 0;
    -moz-user-select: none;
    /*火狐*/
    -webkit-user-select: none;
    /*webkit浏览器*/
    -ms-user-select: none;
    /*IE10*/
    -khtml-user-select: none;
    /*早期浏览器*/
    user-select: none;
}

.btn_list .btn_item {
    padding: 0 20px;
}

.btn_item button:hover {
    background: #efefef;
}

.icon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
}

/* .btn_active {
        background: #efefef;
    } */

.btn_active::before {
    content: "";
    position: absolute;
    bottom: 0;
    width: 80%;
    height: 3px;
    background: #0091ff;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    /* background: #7EB5EE; */
    /* border-top: 2px solid #797979; */
}

.sub_btn_list {
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 8px;
}

.lay_btn {
    /* height: 30px;
        line-height: 5px; */
    color: #3d7cd9;
    border: 1px solid #dcdfe6;
}

.el-dropdown-link {
    display: inline-block;
    padding: 8px 10px;
    border-radius: 3px;
    color: #3d7cd9;
    border: 1px solid #dcdfe6;
}

.lay_btn:hover {
    background: #f7f9ff;
}

/* .content::-webkit-scrollbar {
        display: none;
    } */

.test {
    width: 200px;
    background: #999;
}

.row {
    display: flex;
    flex-direction: row;
}

.btn_center {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.center_active {
    color: #3d7cd9;
}

.export-fixed {
    display: flex;
    width: 100%;
    height: 50px;
    border: 1px solid #000;
    border-top: 0;
    line-height: 52px;
    box-sizing: border-box;
}

.export-text {
    text-align: center;
}

.export-text:nth-of-type(1) {
    width: 150px;
    border-right: 1px solid #000;
}

.export-text:nth-of-type(2) {
    margin-left: 20px;
}

.inforImage {
    width: 17px;
    height: 17px;
}

.layout_bottom >>> .tableBox {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border: 1px solid #ccc;
    border-bottom: 0;
    box-sizing: border-box;
}

.layout_bottom >>> .tableBox td {
    background: #f6f6f6 !important;
}

.layout_bottom >>> .tableBox th {
    font-weight: normal !important;
}

.layout_bottom >>> .tableBox td.gutter,
.layout_bottom >>> .tableBox th.gutter {
    border-bottom: 1px solid #ccc;
    background: #404040;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue